import { Client } from "@/Common/Api/Client";
import { ClientResponse } from "@/Common/Api/ClientResponse";
import { Server } from "@/Common/Operations/operations.server";
import { IUpdatePatientComplianceRequest } from "./Dto/PatientCompliance/UpdatePatientComplianceRequest";

class PatientComplianceClient {
    public static async updatePatientCompliance(request: IUpdatePatientComplianceRequest): Promise<ClientResponse> {
        return await Client.postAsync(
            Server.Myle_Patient_UpdateMedicationPatientCompliance,
            request
        );
    }
}

export { PatientComplianceClient };
